export const publications = [
	{
		"title": "Monocular 3D Human Pose Estimation with Domain Feature Alignment and Self Training",
		"authors-first-part": "Yan-Hong Zhang, ",
		"authors-second-part":", Min-Chun Hu, Hung-Kuo Chu",
		"img": "domain.gif",
		"conference": "IEEE International Conference on Multimedia and Expo (ICME), 2022",
		"summary": "We propose a novel domain feature alignment (DFA) with self training that avoids the disadvantages of unstable training with wrong alignment. We achieved good results in Human 3.6M without using any 3D ground truth real data.",
		"link": "https://ieeexplore.ieee.org/abstract/document/9859808?casa_token=jwzdTh7baR0AAAAA:QehHo8DaahjGZN0Lfs1a28y6ipd314WuNOOQxGT-9lO5IyXKgv4mH9rV7fBclTybyl6YWBym",
	},
	{
		"title": " Assist Home Training Table Tennis Skill Acquisition via Immersive Learning and Web Technologies",
		"authors-first-part": "Jian-Jia Weng, Yu-Hsin Wang, ",
		"authors-second-part": ", Dong-Xian Wu, Yi-Min Lau, Wan-Lun Tsai, Min-Chun Hu, Hung-Kuo Chu, Te-Cheng Wu",
		"img": "posture.gif",
		"conference": "IEEE Conference on Virtual Reality Workshop, 2022",
		"summary": "We developed a Virtual Reality training system with step by step instructions to learn a new table tennis skill and a web posture analysis system, where coach can share their annotation of the trainee's 3D posture.",
		"link": "https://ieeexplore.ieee.org/document/9757442"
	}
];